import {apiTemplate} from "@/core/helpers/api.js";

export class Auth {
  static async register(payload) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        createUser (
          firstName: "${payload.firstName}"
          lastName: "${payload.lastName}"
          email: "${payload.email}"
          password: "${payload.password}"
          confirmPassword: "${payload.passwordConfirm}"
          isSubscribed: false
        ) {
          success
        }
      }`
    );

    return await response;
  }

  static async login(email, password) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        obtainJwtToken (email: "${email}", password: "${password}") {
          accessToken
          refreshToken
          user {
            uuid
            attributes
            language
            email
            firstName
            lastName
            balance {
              amount
            }
          }
        }
      }`
    );

    return await response;
  }

  static async updateUser(data, accessToken) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "X-SCHON-AUTH": `Bearer ${accessToken}`,
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        updateUser (${data}) {
          user {
            uuid
            attributes
            language
            email
            firstName
            lastName
            balance {
              amount
            }
          }
        }
      }`
    );

    return await response;
  }

  static async refresh() {
    const userLocale = localStorage.getItem('fpt-user-locale');
    const token = localStorage.getItem('fpt-refresh')

    if (!token) {
      return false
    } else {
      const response = await apiTemplate(
        {
          "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
        },
        `mutation {
          refreshJwtToken(refreshToken: "${token}") {
            accessToken
            refreshToken
            user {
              uuid
              attributes
              language
              email
              firstName
              lastName
              balance {
                amount
              }
            }
          }
        }`
      );

      return await response;
    }
  }

  static async activateUser(token, uid) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        activateUser(token: "${token}", uid: "${uid}") {
          success
        }
      }`
    );

    return await response;
  }

  static async resetPassword(email) {
    const userLocale = localStorage.getItem('user.ts-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        resetPassword(email: "${email}") {
          success
        }
      }`
    );

    return await response;
  }

  static async confirmResetPassword(uid, token, password, passwordConfirm) {
    const userLocale = localStorage.getItem('user.ts-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        confirmResetPassword(confirmPassword: "${passwordConfirm}", password: "${password}", token: "${token}", uid: "${uid}") {
          success
        }
      }`
    );

    return await response;
  }

  static async setLanguage(userUuid, accessToken, language) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "X-SCHON-AUTH": `Bearer ${accessToken}`,
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        updateUser (uuid: "${userUuid}", language: "${language}") {
          user {
            uuid
            attributes
            language
            email
            firstName
            lastName
            balance {
              amount
            }
          }
        }
      }`
    );

    return await response;
  }
}